import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, EventEmitter, Output, OnDestroy } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, last } from 'rxjs/operators';
import { NaviFreshMartService } from '../../services/navi-fresh-mart.service';
import { Stall } from '../../classes/stall';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PagesModule } from 'src/app/pages/pages.module';
import { MyOrdersComponent } from 'src/app/pages/account/user-account/my-orders/my-orders.component';
import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BarcodeFormat } from '@zxing/library';
import { DomSanitizer } from '@angular/platform-browser';
// import { StatusBar, BackgroundColorOptions, Style} from '@capacitor/status-bar';

@Component({
  selector: 'app-mfg-header',
  templateUrl: './mfg-header.component.html',
  styleUrls: ['./mfg-header.component.scss']
})
export class MfgHeaderComponent implements OnInit, OnDestroy {
  @Input() genieName: string;
  //  @Output() myOrdersSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  qrcodeImg = "../../../../assets/images/qr-code.svg";
  displayHeader: boolean = false;
  headerComponents = ['/shop/machine-prod-items', '/shop/mfg-cart', '/shop/myaccount', '/shop/myorders'];
  machDownArrowIcon = "../../../../assets/images/mach-dropdown.svg";
  machinesList: Stall[] = [];
  modalReference: any;
  currentRoute: string = "";
  isSelected: boolean = false;
  isSelectedProfile: boolean = false;
  user: any;
  searchProdTerm: string = "";
  selectedButton: string = 'profile';

  listIcon = "../../../../assets/images/lisouline.svg";
  listFill = "../../../../assets/images/lisfill.svg";
  setSelectedView: boolean = true;
  isMobileOrDesktop: boolean = false;
  isContainerVisible: boolean = false;
  interval: any;
  linePosition: number = 0;
  ngClassForButtons = "openCamera";
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  hasDevices: boolean;
  hasPermission: boolean;
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;
  MachinestallId: number;
  Machine: Stall;
  switchButtonSubject: any;
  allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.EAN_13, BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX /*, ...*/];
  itemslength: any;
  machineItemCount: any;
  SelectedmachineItem: boolean;
  SelectedmachineItemCount: void;
  headerstallid: any;
  accountId = "";
  allGeniesList: Stall[] = [];
  cloudStatus: string;
  isSearchActive: boolean = false;
  walletBal: number;
  constructor(public dataService: DataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private naviService: NaviFreshMartService,
    private el: ElementRef,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer) {

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkHeaderRoute();
      });
    // this.isMyOrdersSelected()

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {

    const targetElement = event.target as HTMLElement;
    const isClickInsideContainer = targetElement.closest('.search-container');
    console.log("search", isClickInsideContainer);

    if (!isClickInsideContainer) {
      this.isSearchActive = false;

    }
  }
  onMouseEnter() {
    this.isSearchActive = true;
    console.log("enter", this.isSearchActive);

  }

  onMouseLeave() {
    console.log("leave", document.activeElement.classList);

    if (!document.activeElement.classList.contains('search-field')) {
      this.isSearchActive = false;
    }
  }
  onContainerClick() {
    this.isSearchActive = true;
    console.log("click", this.isSearchActive);

  }

  onFocus() {
    this.isSearchActive = true;
  }
  ngOnInit() {
    // to display header for particular component only
    document.addEventListener('click', this.onDocumentClick.bind(this));
    this.user = JSON.parse(localStorage.getItem("user"));
    const payload = {
      accountId: this.user.accountId
    }
    this.naviService.getWalletBalance(payload).subscribe((data) => {
      if (data.balance) {
        this.walletBal = data.balance;
        if (this.user.walletId == null || this.user.walletId == "") {
          this.user.walletId = data.walletId;
          localStorage.setItem('user', JSON.stringify(this.user));
        }
      }

    });
    this.accountId = this.user.accountId;
    this.dataService.genieNameEmitter.subscribe((value) => {
      if (value) this.genieName = value;
    });
    this.dataService.$genieStatusObs.subscribe((value) => {
      if (value != "") this.cloudStatus = value;
    })
    // let machinesList = JSON.parse(localStorage.getItem('machinesList'));
    // this.machinesList = machinesList;
    this.naviService.getMachines(1001, this.user.accountId).subscribe((data) => {
      let machinesList = data;
      machinesList = machinesList.filter(item => (item.type == "Genie" && item.status == "Active"));
      this.machinesList = machinesList;
      this.allMachList();
      // this.calculateDistances(machinesList);
    });
    this.MachinestallId = JSON.parse(localStorage.getItem("genieId"));
    console.log(this.MachinestallId)
    //   if(obj.name == this.genieName){
    //     this.headerstallid = obj.stallid
    //   }
    // })
    // console.log(this.headerstallid,"genieNm")
    this.isSelected = false;
    this.isSelectedProfile = false;
    this.dataService.prodSearchObs$.subscribe((value) => {
      this.searchProdTerm = value !== null ? value : '';
      // if(value!="") this.searchProdTerm = value;

    });
    this.dataService.machineproductItemCount$.subscribe((length: number) => {
      this.itemslength = length;
    });
    // const payload = {
    //   "stallid": this.MachinestallId,
    //   "accountId": this.user.accountId
    // };
    // const resp = this.naviService.fetchdataPost(
    //   'genieinventory/getProductsByGenie',
    //   payload
    // ) .then((productItems: any[]) => {
    //   console.log("Product Items", productItems);
    //   this.itemslength = productItems.length 

    // })
    // .catch(error => {
    //   console.error("Error fetching data:", error);

    // });

    // const user = JSON.parse(localStorage.getItem('user'));
    // onMachineSelect(machine :Stall)
    // this.MachinestallId = this.machinesList.stallid;
    // const payload = {
    //   "stallid": stallid,
    //   "accountId": this.user.accountId
    // };
    // this.isMyOrdersSelected()
  }

  // setStatusBarBackgroundColor(color: string): void {
  //   const options: BackgroundColorOptions = {
  //     color,
  //   };
  //   StatusBar.setBackgroundColor(options);
  // }
  async allMachList() {
    const resp = await this.naviService.
      getMachines(1001, "")
      .subscribe((data) => {
        this.allGeniesList = data;
        this.allGeniesList.forEach((obj) => {
          obj.imageFile = this.sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${obj.imageData}`)
        })
        this.allGeniesList = this.allGeniesList.filter(item => { return item.type == "Genie" && item.status == 'Active' });
        this.allGeniesList.forEach((obj) => {
          obj.favGenie = false;
        });
        this.allGeniesList.forEach((allObj) => {
          this.machinesList.forEach((machine) => {
            if (machine.stallid == allObj.stallid && machine.favGenie == true) {
              allObj.favGenie = true;
              allObj.genFavId = machine.genFavId;
            }

          })
        })
      })
  }
  async onAddtoFav(event, machine: Stall) {
    event.stopPropagation();
    if (machine.favGenie) {
      const payload = {
        genFavId: machine.genFavId
      }
      this.naviService.deleteGenFavId(payload).subscribe((data) => {
        console.log("data deleted", data);
        this.getMachinesList();
      })
    }
    else {
      machine.favGenie = true;
      const payload = {
        accountId: this.accountId,
        stallId: machine.stallid,
        genFavId: 0
      }
      const resp = await this.naviService.
        fetchRequestPost("genfav/createGenFav", payload);
      this.getMachinesList();
    }

  }
  getMachinesList() {
    this.naviService.getMachines(1001, this.accountId).
      subscribe((data) => {

        this.machinesList = data;
        this.machinesList.forEach((obj) => {
          obj.imageFile = this.sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${obj.imageData}`)
        })
        this.machinesList = this.machinesList.
          filter(item => {
            return item.type == "Genie"
              && item.status == 'Active'
          });
        this.allMachList();
        // this.calculateDistances();



      });
  }
  onSubcatView() {


    this.setSelectedView = !this.setSelectedView;
    this.dataService.setSelectedView(this.setSelectedView);
  }
  calculateDistances(machinesList) {
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLatitude = position.coords.latitude;
          const currentLongitude = position.coords.longitude;
          console.log('lat', currentLatitude, 'long', currentLongitude);
          // Calculate distances and add them to each object
          machinesList.forEach((location) => {
            // const match = location.address.match(/Latitude:\s*([\d.]+),\s*Longitude:\s*([\d.]+)/);
            const [latitudeStr, longitudeStr] = location.address.split(',');


            const latitude = parseFloat(latitudeStr);
            const longitude = parseFloat(longitudeStr);

            // Calculate distance using the Haversine formula
            const distance = this.calculateHaversineDistance(
              currentLatitude,
              currentLongitude,
              latitude,
              longitude
            );

            // Add the distance to the object
            console.log("distance", distance);
            const formattedDistance = parseFloat(distance.toFixed(2));
            location.distanceFromCurrentLocation = formattedDistance;

            // else location.distanceFromCurrentLocation = null;
          });
          machinesList.forEach((machine: Stall) => {
            if (machine.distanceFromCurrentLocation > 0) {
              machine.distanceInKm = parseFloat((machine.distanceFromCurrentLocation / 1000).toFixed(2));
            }
          })
          this.machinesList = machinesList;

          console.log("afterloca", machinesList);
          this.machinesList = this.machinesList.filter((machine) => {
            return machine.distanceFromCurrentLocation != null && machine.distanceFromCurrentLocation <= machine.locationRange;
          })
          localStorage.setItem('machinesList', JSON.stringify(this.machinesList));
        },
        (error) => {
          console.error('Error getting current location:', error);
        },
        options
      );
    } else {
      console.error('Geolocation is not available in this browser.');
    }
  }
  calculateHaversineDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number {
    const earthRadius = 6371; // Earth's radius in kilometers

    let dLat = (lat2 - lat1) * Math.PI / 180.0;
    let dLon = (lon2 - lon1) * Math.PI / 180.0;
    lat1 = lat1 * Math.PI / 180.0;
    lat2 = lat2 * Math.PI / 180.0;

    let a = Math.sin(dLat / 2.0) * Math.sin(dLat / 2.0) +
      Math.sin(dLon / 2.0) * Math.sin(dLon / 2.0) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = earthRadius * c;

    return d * 1000;
  }

  // Convert degrees to radians
  toRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
  }
  onClearSearch() {
    this.searchProdTerm = '';
    this.dataService.setProdTerm(this.searchProdTerm);
    // this.cdr.detectChanges();

  }

  // isMyOrdersSelected(): void {

  //   // Logic to determine if "My Orders" button is selected
  //   let isSelected = this.router.isActive('/pages/my-orders', true); // Replace with actual logic

  //   this.myOrdersSelected.emit(isSelected);
  // }
  async OnScanPress(modal) {

    if (Capacitor.getPlatform() != "web") {
      this.isMobileOrDesktop = true;
      const result = await Camera.requestPermissions();
      if (result.camera === 'granted') {
        console.log('Camera permissions granted.');
        this.modalReference = this.modalService.open(modal);
        this.animateLine();
        // Proceed with camera operations
      } else {
        console.log('Camera permissions denied.');
        return
        // Handle the denied permissions
      }
    }
    else {
      this.modalReference = this.modalService.open(modal);
      if (window.innerWidth <= 700) this.isMobileOrDesktop = true;
      else this.isMobileOrDesktop = false;
      this.animateLine();
    }




  }
  onClose() {
    this.modalReference.close();
    if (this.interval) clearInterval(this.interval);
  }
  onScanSuccess(qrresult: string) {
    this.modalReference.close();
    let lastSegment = "";
    if (qrresult.includes("GEN_")) {
      const parts = qrresult.split("#");
      if (parts.length > 1) {
        console.log(parts[1]);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([`${parts[1]}`], { replaceUrl: true });
      }
    }
    if (qrresult.includes("SLT_")) {
      const parts = qrresult.split("#");
      if (parts.length > 1) {
        console.log(parts[1]);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([`${parts[1]}`], { replaceUrl: true });
      }
    }
    if (!qrresult.includes("GEN_") && !qrresult.includes("SLT_")) {
      const machIdOrDisplayId = qrresult;
      const machineObj = this.machinesList.find(obj => obj.stallid == parseInt(machIdOrDisplayId) || obj.vmsMachId == machIdOrDisplayId);
      if (machineObj) {
        this.dataService.setMachineId(machineObj.stallid);
        localStorage.setItem("genieName", machineObj.name);
        localStorage.setItem('genieId', machineObj.stallid + "");
        this.dataService.UpdateGenieName(machineObj.name);
        this.dataService.setGenieStatus(machineObj.cloudStatus);

        // temporary
        //  this.dataService.setIsSearchDisable(true);

      }
      else {
        this.snackBar.open("Wrong Machine QR Code", 'X', {
          panelClass: 'toast-message',
          duration: 5000
        })
      }
    }











  }
  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
    if (!this.hasPermission) {
      alert("Camera access is blocked Please Goto Chrome Settings -> Site Settings -> Allow Camera for https://myfoodgenie.com");
    }
  }
  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }
  animateLine() {
    this.isContainerVisible = true;
    this.interval = setInterval(() => {
      this.linePosition += 1;

      if (this.linePosition >= 100) {
        this.linePosition = 0;
      }
    }, 10); // Adjust the interval as needed
  }

  onError(error) {
    console.log(error);
  }
  capturedQr(result: string) {
    // this.isqrscanner=true;
    // alert(result);
    console.log("result", result);
    const scannedOrderId = result;

    const machineObj = this.machinesList.find(obj => obj.stallid == parseInt(result));
    if (machineObj) {
      this.dataService.setMachineId(machineObj.stallid);
      localStorage.setItem("genieName", machineObj.name);
      localStorage.setItem('genieId', machineObj.stallid + "");
      this.dataService.UpdateGenieName(machineObj.name);
      this.dataService.setGenieStatus(machineObj.cloudStatus);

      // temporary
      //  this.dataService.setIsSearchDisable(true);

    }






  }
  onOrders() {

    this.router.navigate(['shop/myorders']);
    this.dataService.setSelectedButton('orders');

    // this.selectedButton = 'orders';
    // this.isSelected = true;
    // this.isSelectedProfile = false;
  }
  onProfile() {
    // this.isSelectedProfile = true;
    // this.isSelected = false;
    this.router.navigate(['shop/myaccount']);
    this.dataService.setSelectedButton('profile');
    // this.selectedButton = 'profile';
  }
  onProdSearchChange(value) {
    console.log(value);
    this.dataService.setProdTerm(value);
  }
  OnClosePress() {
    this.router.navigate(['shop/machine-prod-items'])
  }
  checkHeaderRoute() {

    console.log("router", this.router.url);
    const currentRoute = this.router.url;
    if (currentRoute.startsWith('/shop/mfg/')) {
      this.currentRoute = currentRoute;
      this.displayHeader = true;
    }
    else if (currentRoute) {
      console.log("route", currentRoute);
      this.currentRoute = currentRoute;
      // Access the component's name or any identifier you want to use
      this.displayHeader = this.headerComponents.includes(currentRoute);
    }
  }
  openPopup(modal) {
    this.modalReference = this.modalService.open(modal, { size: "sm" });
  }
  onMachineSelect(machine: Stall) {
    this.MachinestallId = machine.stallid;
    this.Machine = machine;
    this.dataService.setMachineId(machine.stallid);
    localStorage.setItem("genieName", machine.name);
    localStorage.setItem('genieId', machine.stallid + "");
    this.dataService.UpdateGenieName(machine.name);
    this.dataService.setGenieStatus(machine.cloudStatus);

    // temporary
    //  this.dataService.setIsSearchDisable(true);
    this.modalReference.close();
  }
  onMachineView2() {

    // this.dataService.setMachineId(this.MachinestallId);
    // localStorage.setItem("genieName", this.Machine.name);
    // localStorage.setItem('genieId', this.Machine.stallid+"");
    // this.dataService.UpdateGenieName(this.Machine.name);
  }
  isRouteStartsWith(pattern: string): boolean {
    return this.currentRoute.startsWith(pattern);
  }
  ngOnDestroy() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }
}
